import React, { Component } from 'react';
import {
  formatPercent,
  formatTextFloat,
  formatChange,
} from '../../../../helpers/Text';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { getColor, getTimeRange } from '../helper';
import Status from './Status';
import moment from 'moment';

class Commodity extends Component {
  getTimeRange = () => {
    const { dailyDate: endDate, data } = this.props;
    const startDate = moment(Object.values(data)[0].tradingDate).format('l');

    return `(${startDate} - ${endDate})`;
  };

  getClassName = value => {
    return value > 0
      ? 'text-increase index-change'
      : 'text-decrease index-change';
  };

  render() {
    let { data, className, dailyDate } = this.props;
    const i18nKey = 'marketInDepthProspect.prospectItem';
    const prospectName = I18n.t(`${i18nKey}.commodity`);
    className = [className, 'prospect-item flip-container vertical'].join(' ');

    return (
      <div
        className={className}
        style={{
          backgroundColor: getColor(data.oilWtiPrice.priceChange),
        }}
      >
        <div className="flipper">
          <div className="prospect-no-hover front">
            {/* Name */}
            <div className="prospect-item__title">
              <span>{prospectName}</span>
            </div>

            <Status value={data.oilWtiPrice.priceChange} />
          </div>

          <div className="prospect-item-hover back">
            <div className="prospect-item__title">
              <span>{prospectName}</span>
              <span className="ml-5 time-range">
                {this.getTimeRange(dailyDate, data)}
              </span>
            </div>

            <div className="prospect-item__content">
              <div className="prospect-item__row">
                <span className="label">
                  {I18n.t(`${i18nKey}.oilWtiPrice`)}
                </span>
                <strong>
                  {`${formatTextFloat(data.oilWtiPrice.price)} `}
                  <span
                    className={this.getClassName(data.oilWtiPrice.priceChange)}
                  >
                    (
                    {`${formatChange(
                      formatTextFloat(data.oilWtiPrice.priceChange),
                    )} ~ ${formatTextFloat(
                      formatPercent(data.oilWtiPrice.percentPriceChange),
                    )}%`}
                    )
                  </span>
                </strong>
              </div>

              <div className="prospect-item__row">
                <span className="label">
                  {I18n.t(`${i18nKey}.brentOilPrice`)}
                </span>
                <strong>
                  {`${formatTextFloat(data.brentOilPrice.price)} `}
                  <span
                    className={this.getClassName(
                      data.brentOilPrice.priceChange,
                    )}
                  >
                    (
                    {`${formatChange(
                      formatTextFloat(data.brentOilPrice.priceChange),
                    )} ~ ${formatTextFloat(
                      formatPercent(data.brentOilPrice.percentPriceChange),
                    )}%`}
                    )
                  </span>
                </strong>
              </div>

              <div className="prospect-item__row">
                <span className="label">
                  {I18n.t(`${i18nKey}.worldGoldPrice`)}
                </span>
                <strong>
                  {`${formatTextFloat(data.worldGoldPrice.buyPrice)} `}
                  <span
                    className={this.getClassName(
                      data.worldGoldPrice.buyPriceChange,
                    )}
                  >
                    (
                    {`${formatChange(
                      formatTextFloat(data.worldGoldPrice.buyPriceChange),
                    )} ~ ${formatTextFloat(
                      formatPercent(data.worldGoldPrice.percentBuyPriceChange),
                    )}%`}
                    )
                  </span>
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(Commodity);
